import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'

export class CheckIMEIVodafoneApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/checkIMEIVodafone',
      requesterInfo,
    })
  }

  public async checkIMEI(data: any): Promise<any> {
    return await this.postAsync<any>(data)
  }
}
